<script setup lang="ts">
import { Head } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <meta head-key="robots" name="robots" content="noindex, nofollow" />
    </Head>
</template>
